"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withIndestructibleElements = void 0;
var _slate = require("slate");
var _plateCommon = require("@udecode/plate-common");
/* written from scratch since I could not find a reliable plate-js way of making a node completely read-only */

/* extend if we need more indestructible elements */
var ELEMENT_NON_EDITABLE_CONTENT = 'non-editable-content';
var isNonEditableElement = function isNonEditableElement(node) {
  return (0, _plateCommon.isElement)(node) && node.type === ELEMENT_NON_EDITABLE_CONTENT;
};
// Function to check if any node along the path is non-editable
var containsNonEditable = function containsNonEditable(editor, start, end) {
  var _ref = _slate.Path.isBefore(start, end) ? [start, end] : [end, start],
    _ref2 = _slicedToArray(_ref, 2),
    firstPath = _ref2[0],
    lastPath = _ref2[1]; // Use Editor.nodes to iterate through each node in the selection path
  var _iterator = _createForOfIteratorHelper(_slate.Editor.nodes(editor, {
      at: {
        anchor: {
          path: firstPath,
          offset: 0
        },
        focus: {
          path: lastPath,
          offset: 0
        }
      }
    })),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 1),
        node = _step$value[0];
      if (isNonEditableElement(node)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};
function isNonEditableElementInsideSelection(editor) {
  var selection = editor.selection;
  if (selection) {
    var _slate$Range$edges = _slate.Range.edges(selection),
      _slate$Range$edges2 = _slicedToArray(_slate$Range$edges, 2),
      start = _slate$Range$edges2[0],
      end = _slate$Range$edges2[1];
    if (containsNonEditable(editor, start.path, end.path)) {
      return true; // Prevent deletion if a non-editable element is within the selected range
    }
  }
}
var withIndestructibleElements = function withIndestructibleElements(editor) {
  var deleteBackward = editor.deleteBackward,
    deleteForward = editor.deleteForward,
    deleteFragment = editor.deleteFragment,
    insertText = editor.insertText;
  editor.deleteBackward = function (unit) {
    var selection = editor.selection; // only go here if the selection is collapsed, meaning it's just a cursor
    if (selection && _slate.Range.isCollapsed(selection)) {
      var _slate$Editor$nodes = _slate.Editor.nodes(editor, {
          match: function match(n) {
            return isNonEditableElement(n);
          },
          at: _slate.Editor.before(editor, selection)
        }),
        _slate$Editor$nodes2 = _slicedToArray(_slate$Editor$nodes, 1),
        matchBefore = _slate$Editor$nodes2[0];
      if (matchBefore) {
        return; // Prevent deletion of the non-editable element
      }
    }
    deleteBackward(unit); // Default behavior otherwise
  };
  editor.deleteForward = function (unit) {
    var selection = editor.selection; // only go here if the selection is collapsed, meaning it's just a cursor
    if (selection && _slate.Range.isCollapsed(selection)) {
      var _slate$Editor$nodes3 = _slate.Editor.nodes(editor, {
          match: function match(n) {
            return isNonEditableElement(n);
          },
          at: _slate.Editor.after(editor, selection)
        }),
        _slate$Editor$nodes4 = _slicedToArray(_slate$Editor$nodes3, 1),
        matchAfter = _slate$Editor$nodes4[0];
      if (matchAfter) {
        return; // Prevent deletion of the non-editable element
      }
    }
    deleteForward(unit); // Default behavior otherwise
  };
  editor.deleteFragment = function () {
    if (isNonEditableElementInsideSelection(editor)) {
      return; // Prevent deletion of the non-editable element
    }
    deleteFragment(); // Default behavior otherwise
  };
  editor.insertText = function (text) {
    if (isNonEditableElementInsideSelection(editor)) {
      return; // Prevent deletion of the non-editable element
    }
    insertText(text); // Default behavior otherwise
  };
  return editor;
};
exports.withIndestructibleElements = withIndestructibleElements;